import {Stack, Typography} from '@mui/material';
import React, {Fragment, memo, useEffect} from 'react';

import {useQueryParams} from 'presentation/pages/private/hooks';
import {useLocationStore} from 'presentation/pages/private/store/locationStore';
import {FlowType} from 'presentation/pages/private/store/locationStore/constants';
import {translations} from 'presentation/translations-new';
import {getUserInfoFromToken} from 'presentation/utils';
import {TypeLocalNameEnum} from 'domain/usecases';
import {DistrictCheckbox} from '../DistrictCheckbox';
import {StyledDistrictGrid} from './styles';
import {DistrictCheckboxProps} from './types';

const {selectDistrict, all, selectAll} = translations['pt-br'].commons;

export const DistrictList = memo(
	({list, handleSelectCard, selectedDistricts, allDistrictsSelected}: DistrictCheckboxProps) => {
		const cdPessoaC = getUserInfoFromToken().cdPessoa;
		const getLocation = useLocationStore(state => state.getLocation);
		const selectedLocation = getLocation(cdPessoaC, FlowType.HEALTH_GUIDE);
		const {typeLocalName} = selectedLocation;
		const showCityName = typeLocalName === TypeLocalNameEnum.ZONA;

		const {SEARCH_PARAMS} = useQueryParams();
		const {query} = SEARCH_PARAMS;

		const FILTERED_DISTRICT_LIST =
			list?.filter(districtItem =>
				districtItem.bairro.toLowerCase().includes(query?.trim().toLowerCase() ?? ''),
			) ?? [];

		const showEmptyState = FILTERED_DISTRICT_LIST.length === 0;

		useEffect(() => {
			handleSelectCard(`${all}-${selectAll}`, true);
		}, []);

		if (showEmptyState) {
			return null;
		}

		return (
			<Fragment>
				<Typography variant="subtitle2" color="text.secondary" mb={2}>
					{selectDistrict}
				</Typography>
				<Stack gap={2}>
					<StyledDistrictGrid>
						{query ? null : (
							<DistrictCheckbox
								handleSelectCard={handleSelectCard}
								checked={!!allDistrictsSelected}
								district={all}
								city={selectAll}
								query={''}
								allDistrictsSelected={false}
								showCityName={showCityName}
							/>
						)}

						{FILTERED_DISTRICT_LIST.map(item => (
							<DistrictCheckbox
								key={`${item.bairro}-${item.cidade}`}
								handleSelectCard={handleSelectCard}
								checked={selectedDistricts.includes(
									`${item.bairro}-${item.cidade}`,
								)}
								district={item.bairro}
								city={item.cidade}
								query={query || ''}
								allDistrictsSelected={allDistrictsSelected}
								showCityName={showCityName}
							/>
						))}
					</StyledDistrictGrid>
				</Stack>
			</Fragment>
		);
	},
);
